module.exports = __webpack_public_path__ + "media/images/icons/fast-msg-f69c27ef7480017d4e424633029fbbb9.svg";